// import React, { useState } from 'react'
// import { useTranslation } from 'react-i18next'
// import { Link } from 'react-router-dom'
// import CleanEnergyMineralIcon from '../../../icons/CleanEnergyMineralIcon'
// import IndustrialMineralsIcon from '../../../icons/IndustrialMineralsIcon'
// import SecurityMineralIcon from '../../../icons/SecurityMineralIcon'

// const cleanEnergyLinks = [
//   { label: 'MINERALS_OVERVIEW', route: 'future-minerals?category=1' },
//   { label: 'FUTURE_MINERALS_REGION', route: 'future-minerals/region?category=1' },
//   { label: 'ARAB_PRODUCTION', route: 'future-minerals/clean-energy/arab-production' },
//   { label: 'VALUE_CHAIN', route: 'future-minerals/value-chains?category=1' },
//   { label: 'GLOBAL_DEMAND', route: 'future-minerals/clean-energy/global-demand' },
//   { label: 'CLEAN_ENERGY_TECHNOLOGIES', route: 'future-minerals/clean-energy/technologies' },
// ]

// const industrialLinks = [
//   { label: 'MINERALS_OVERVIEW', route: 'future-minerals?category=2' },
//   { label: 'FUTURE_MINERALS_REGION', route: 'future-minerals/region?category=2' },
//   { label: 'ARAB_PRODUCTION', route: 'future-minerals/industrial/arab-production' },
//   { label: 'VALUE_CHAIN', route: 'future-minerals/value-chains?category=2' },
//   { label: 'MAIN_INDUSTRIES', route: 'future-minerals/industrial/industries' },
// ]

// const securityLinks = [
//   { label: 'MINERALS_OVERVIEW', route: 'future-minerals?category=4' },
//   { label: 'FUTURE_MINERALS_REGION', route: 'future-minerals/region?category=4' },
//   { label: 'ARAB_PRODUCTION', route: 'future-minerals/security/arab-production' },
//   { label: 'VALUE_CHAIN', route: 'future-minerals/value-chains?category=4' },
//   { label: 'AGRICULTURAL_APPLICATIONS', route: 'future-minerals/security/securities' },
// ]

// export default function NavbarDesktopDropdown({ lng }) {
//   const { t } = useTranslation()
  
//   // Utilisation d'un seul état pour savoir quel sous-menu est ouvert (ou null si aucun)
//   const [activeCategory, setActiveCategory] = useState(null)

//   return (
//     <div className="absolute top-full z-50 pt-4 ltr:left-0 rtl:right-0">
//       <div className="border-muted-300 relative border-2 bg-light p-2">
//         <ul className="flex flex-col gap-2">
          
//           {/* 1. Clean Energy Minerals */}
//           <li 
//             onMouseEnter={() => setActiveCategory('cleanEnergy')}
//             onMouseLeave={() => setActiveCategory(null)}
//             className="relative"
//           >
//             <div
//               className={`flex border-2 ${activeCategory === 'cleanEnergy' ? 'bg-cleanEnergy text-white' : 'bg-white text-cleanEnergy hover:bg-cleanEnergy hover:text-white'} cursor-default items-center border-cleanEnergy`}
//             >
//               <div className="bg-cleanEnergy p-2">
//                 <CleanEnergyMineralIcon size={22} color={'#ffff'} />
//               </div>
//               <div className="whitespace-nowrap ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4 cursor-pointer">{t('CLEAN_ENERGY_MINERALS')}</div>
//             </div>
            
//             {activeCategory === 'cleanEnergy' && (
//               <div className="absolute -top-[10px] ltr:left-full ltr:pl-3 rtl:right-full rtl:pr-3 z-[60]">
//                 <div className="border-2 border-muted-300 bg-light p-2 relative">
//                   <div className="absolute top-[18px] h-3 w-3 -rotate-45 bg-light ltr:-left-1.5 ltr:border-b-2 ltr:border-r-2 rtl:-right-1.5 rtl:border-l-2 rtl:border-t-2 z-10" />
//                   <ul className="flex flex-col gap-2 whitespace-nowrap text-white">
//                     {cleanEnergyLinks.map((link) => (
//                       <li key={link.label}>
//                         <Link
//                           className="border-muted-300 flex border-2 bg-white py-2 text-cleanEnergy hover:border-cleanEnergy hover:bg-cleanEnergy hover:text-white ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4"
//                           to={`/${lng}/${link.route}`}
//                         >
//                           {t(link.label)}
//                         </Link>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               </div>
//             )}
//           </li>

//           {/* 2. Industrial Minerals */}
//           <li 
//             onMouseEnter={() => setActiveCategory('industrial')}
//             onMouseLeave={() => setActiveCategory(null)}
//             className="relative"
//           >
//             <div
//               className={`flex border-2 ${activeCategory === 'industrial' ? 'bg-industrial text-white' : 'bg-white text-industrial hover:bg-industrial hover:text-white'} cursor-default items-center border-industrial`}
//             >
//               <div className="bg-industrial p-2">
//                 <IndustrialMineralsIcon size={22} color={'#ffff'} />
//               </div>
//               <div className="whitespace-nowrap ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4 cursor-pointer">{t('INDUSTRIAL_MINERALS')}</div>
//             </div>
            
//             {activeCategory === 'industrial' && (
//               <div className="absolute -top-[60px] ltr:left-full ltr:pl-3 rtl:right-full rtl:pr-3 z-[60]">
//                 <div className="border-2 border-muted-300 bg-light p-2 relative">
//                   <div className="absolute top-[70px] h-3 w-3 -rotate-45 bg-light ltr:-left-1.5 ltr:border-b-2 ltr:border-r-2 rtl:-right-1.5 rtl:border-l-2 rtl:border-t-2 z-10" />
//                   <ul className="flex flex-col gap-2 whitespace-nowrap text-white">
//                     {industrialLinks.map((link) => (
//                       <li key={link.label}>
//                         <Link
//                           className="border-muted-300  flex border-2 bg-white py-2 text-industrial hover:border-industrial hover:bg-industrial hover:text-white ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4"
//                           to={`/${lng}/${link.route}`}
//                         >
//                           {t(link.label)}
//                         </Link>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               </div>
//             )}
//           </li>

//           {/* 3. FOOD Minerals */}
//           <li 
//             onMouseEnter={() => setActiveCategory('security')}
//             onMouseLeave={() => setActiveCategory(null)}
//             className="relative"
//           >
//             <div
//               className={`flex border-2 ${activeCategory === 'security' ? 'bg-security text-white' : 'bg-white text-security hover:bg-security hover:text-white'} cursor-default items-center border-security`}
//             >
//               <div className="bg-security p-2">
//                 <img src="/assets/icons/security-color-header/security-food-icon.svg" alt="" className="h-5 w-5" />
//               </div>
//               <div className="whitespace-nowrap ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4 cursor-pointer">{t('FOOD_SECURITY_MINERALS')}</div>
//             </div>
            
//             {activeCategory === 'security' && (
//               <div className="absolute -top-[110px] ltr:left-full ltr:pl-3 rtl:right-full rtl:pr-3 z-[60]">
//                 <div className="border-2 border-muted-300 bg-light p-2 relative">
//                   <div className="absolute top-[120px] h-3 w-3 -rotate-45 bg-light ltr:-left-1.5 ltr:border-b-2 ltr:border-r-2 rtl:-right-1.5 rtl:border-l-2 rtl:border-t-2 z-10" />
//                   <ul className="flex flex-col gap-2 whitespace-nowrap text-white">
//                     {securityLinks.map((link) => (
//                       <li key={link.label}>
//                         <Link
//                           className="border-muted-300 flex border-2 bg-white py-2 text-security hover:border-security hover:bg-security hover:text-white ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4"
//                           to={`/${lng}/${link.route}`}
//                         >
//                           {t(link.label)}
//                         </Link>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               </div>
//             )}
//           </li>

//         </ul>
//         <div className="absolute -top-2 h-3 w-3 rotate-45 border-l-2 border-t-2 bg-light ltr:left-14 rtl:right-14" />
//       </div>
//     </div>
//   )
// }










import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import CleanEnergyMineralIcon from '../../../icons/CleanEnergyMineralIcon'
import IndustrialMineralsIcon from '../../../icons/IndustrialMineralsIcon'
import SecurityMineralIcon from '../../../icons/SecurityMineralIcon'

const cleanEnergyLinks = [
  { label: 'MINERALS_OVERVIEW', route: 'future-minerals?category=1' },
  { label: 'FUTURE_MINERALS_REGION', route: 'future-minerals/region?category=1' },
  { label: 'ARAB_PRODUCTION', route: 'future-minerals/clean-energy/arab-production' },
  { label: 'VALUE_CHAIN', route: 'future-minerals/value-chains?category=1' },
  { label: 'GLOBAL_DEMAND', route: 'future-minerals/clean-energy/global-demand' },
  { label: 'CLEAN_ENERGY_TECHNOLOGIES', route: 'future-minerals/clean-energy/technologies' },
]

const industrialLinks = [
  { label: 'MINERALS_OVERVIEW', route: 'future-minerals?category=2' },
  { label: 'FUTURE_MINERALS_REGION', route: 'future-minerals/region?category=2' },
  { label: 'ARAB_PRODUCTION', route: 'future-minerals/industrial/arab-production' },
  { label: 'VALUE_CHAIN', route: 'future-minerals/value-chains?category=2' },
  { label: 'MAIN_INDUSTRIES', route: 'future-minerals/industrial/industries' },
]

const securityLinks = [
  { label: 'MINERALS_OVERVIEW', route: 'future-minerals?category=4' },
  { label: 'FUTURE_MINERALS_REGION', route: 'future-minerals/region?category=4' },
  { label: 'ARAB_PRODUCTION', route: 'future-minerals/security/arab-production' },
  { label: 'VALUE_CHAIN', route: 'future-minerals/value-chains?category=4' },
  { label: 'AGRICULTURAL_APPLICATIONS', route: 'future-minerals/security/securities' },
]

export default function NavbarDesktopDropdown({ lng }) {
  const { t } = useTranslation()
  const [activeCategory, setActiveCategory] = useState(null)

  // La flèche s'oriente dynamiquement vers l'extérieur (gauche en anglais, droite en arabe pour le sous-menu)
  const ArrowIndicator = () => (
    <span 
      className={`inline-block text-[10px] px-4 ${
        lng === 'ar' ? 'rotate-90' : '-rotate-90'
      }`}
    >
      ▼
    </span>
  )

  return (
    <div className="absolute top-full z-50 pt-4 ltr:left-0 rtl:right-0">
      <div className="border-muted-300 relative border-2 bg-light p-2">
        <ul className="flex flex-col gap-2 w-full">
          
          {/* 1. Clean Energy Minerals */}
          <li 
            onMouseEnter={() => setActiveCategory('cleanEnergy')}
            onMouseLeave={() => setActiveCategory(null)}
            className="relative"
          >
            <div
              className={`flex w-full items-center justify-between cursor-pointer border-2 border-cleanEnergy ${
                activeCategory === 'cleanEnergy' ? 'bg-cleanEnergy text-white' : 'bg-white text-cleanEnergy hover:bg-cleanEnergy hover:text-white'
              }`}
            >
              <div className="flex items-center">
                <div className="bg-cleanEnergy p-2">
                  <CleanEnergyMineralIcon size={22} color={'#ffff'} />
                </div>
                <div className="whitespace-nowrap px-4 font-bold">{t('CLEAN_ENERGY_MINERALS')}</div>
              </div>
              <ArrowIndicator />
            </div>
            
            {activeCategory === 'cleanEnergy' && (
              <div className="absolute -top-[10px] ltr:left-full ltr:pl-3 rtl:right-full rtl:pr-3 z-[60]">
                <div className="border-2 border-muted-300 bg-light p-2 relative">
                  <div className="absolute top-[18px] h-3 w-3 -rotate-45 bg-light ltr:-left-1.5 ltr:border-b-2 ltr:border-r-2 rtl:-right-1.5 rtl:border-l-2 rtl:border-t-2 z-10" />
                  <ul className="flex flex-col gap-2 whitespace-nowrap text-white">
                    {cleanEnergyLinks.map((link) => (
                      <li key={link.label}>
                        <Link
                          className="border-muted-300 flex border-2 bg-white py-2 text-cleanEnergy hover:border-cleanEnergy hover:bg-cleanEnergy hover:text-white ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4"
                          to={`/${lng}/${link.route}`}
                        >
                          {t(link.label)}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </li>

          {/* 2. Industrial Minerals */}
          <li 
            onMouseEnter={() => setActiveCategory('industrial')}
            onMouseLeave={() => setActiveCategory(null)}
            className="relative"
          >
            <div
              className={`flex w-full items-center justify-between cursor-pointer border-2 border-industrial ${
                activeCategory === 'industrial' ? 'bg-industrial text-white' : 'bg-white text-industrial hover:bg-industrial hover:text-white'
              }`}
            >
              <div className="flex items-center">
                <div className="bg-industrial p-2">
                  <IndustrialMineralsIcon size={22} color={'#ffff'} />
                </div>
                <div className="whitespace-nowrap px-4 font-bold">{t('INDUSTRIAL_MINERALS')}</div>
              </div>
              <ArrowIndicator />
            </div>
            
            {activeCategory === 'industrial' && (
              <div className="absolute -top-[60px] ltr:left-full ltr:pl-3 rtl:right-full rtl:pr-3 z-[60]">
                <div className="border-2 border-muted-300 bg-light p-2 relative">
                  <div className="absolute top-[70px] h-3 w-3 -rotate-45 bg-light ltr:-left-1.5 ltr:border-b-2 ltr:border-r-2 rtl:-right-1.5 rtl:border-l-2 rtl:border-t-2 z-10" />
                  <ul className="flex flex-col gap-2 whitespace-nowrap text-white">
                    {industrialLinks.map((link) => (
                      <li key={link.label}>
                        <Link
                          className="border-muted-300 flex border-2 bg-white py-2 text-industrial hover:border-industrial hover:bg-industrial hover:text-white ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4"
                          to={`/${lng}/${link.route}`}
                        >
                          {t(link.label)}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </li>

          {/* 3. FOOD Minerals */}
          <li 
            onMouseEnter={() => setActiveCategory('security')}
            onMouseLeave={() => setActiveCategory(null)}
            className="relative"
          >
            <div
              className={`flex w-full items-center justify-between cursor-pointer border-2 border-security ${
                activeCategory === 'security' ? 'bg-security text-white' : 'bg-white text-security hover:bg-security hover:text-white'
              }`}
            >
              <div className="flex items-center">
                <div className="bg-security p-2">
                  <img src="/assets/icons/security-color-header/security-food-icon.svg" alt="" className="h-5 w-5" />
                </div>
                <div className="whitespace-nowrap px-4 font-bold">{t('FOOD_SECURITY_MINERALS')}</div>
              </div>
              <ArrowIndicator />
            </div>
            
            {activeCategory === 'security' && (
              <div className="absolute -top-[110px] ltr:left-full ltr:pl-3 rtl:right-full rtl:pr-3 z-[60]">
                <div className="border-2 border-muted-300 bg-light p-2 relative">
                  <div className="absolute top-[120px] h-3 w-3 -rotate-45 bg-light ltr:-left-1.5 ltr:border-b-2 ltr:border-r-2 rtl:-right-1.5 rtl:border-l-2 rtl:border-t-2 z-10" />
                  <ul className="flex flex-col gap-2 whitespace-nowrap text-white">
                    {securityLinks.map((link) => (
                      <li key={link.label}>
                        <Link
                          className="border-muted-300 flex border-2 bg-white py-2 text-security hover:border-security hover:bg-security hover:text-white ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4"
                          to={`/${lng}/${link.route}`}
                        >
                          {t(link.label)}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </li>

        </ul>
        <div className="absolute -top-2 h-3 w-3 rotate-45 border-l-2 border-t-2 bg-light ltr:left-14 rtl:right-14" />
      </div>
    </div>
  )
}